import React, { useEffect, useRef, useState } from "react";
import Icon from "../../../../basic/icons";
import Button from "../../../../basic/button";
import { buildAnalytics, DataAnalyticsLocations, DataAnalyticsTypes } from "../../../../basic/analytics";
import Flyout from "./flyout";
export default function MenuItem({
  selectedMenu,
  name,
  handleClick,
  selectedMenuParent,
  color,
  subNavMap,
  index
}: {
  selectedMenu: string;
  name: string;
  handleClick: () => void;
  selectedMenuParent: string;
  color?: boolean,
  subNavMap: any,
  index: any
}): JSX.Element {

      const [selectedMenuFlag, setSelectedMenuFlag] = useState(false);
  
  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setSelectedMenuFlag(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleKeyDown = (event: any) => {
    if (event.key === "Escape") {
      setSelectedMenuFlag(false);
    }
  };
  const dropdownRef = useRef<HTMLDivElement>(null);

  const handleChange=()=>{
    setSelectedMenuFlag(true);
    handleClick();
  }

  return (
    <div  ref={dropdownRef} onKeyDown={handleKeyDown} data-testid="menu-items">
      <button
        type="button"
        className={`flex items-center text-md p-0 border-b-2 dropbtn
        border-transparent ${color === true ? "text-white" : "text-secondary-400"}`}
        onClick={handleChange}
        aria-expanded={selectedMenuFlag}
        aria-haspopup={selectedMenuFlag}
        aria-label={`${name} Main Menu`}
      >
        {name}<Icon name="sortedArrow" className={`text-md text-white hover:text-secondary-300 ml-1`} aria-hidden="true" />
      </button>
      {selectedMenuFlag && (name === selectedMenu) && <Flyout subNavMap={subNavMap} selectedMenu={name} index={index} />}
    </div>

  );
}
